import{B as M}from"./chunk-BaseElement-COVKFV2h.js";import{c as O}from"./chunk-constructorio-BM-KWYOi.js";import{a as z,b as A}from"./chunk-price-filter-GAuhIV8Y.js";import{x as l,T as y}from"./chunk-lit-element-CULRVKo8.js";import{c as w}from"./chunk-repeat-CLr2jifB.js";import{t as E}from"./chunk-custom-element-BhZVzxrc.js";import{n as b}from"./chunk-property-BXqvfTtY.js";import"./chunk-constructorio-DC2whJ13.js";import"./chunk-directive-CF8sV3Lr.js";import"./chunk-directive-helpers-R4cBqjor.js";var L=Object.defineProperty,N=Object.getOwnPropertyDescriptor,m=(e,t,s,r)=>{for(var a=r>1?void 0:r?N(t,s):t,d=e.length-1,i;d>=0;d--)(i=e[d])&&(a=(r?i(t,s,a):i(a))||a);return r&&a&&L(t,s,a),a};let h=class extends M{constructor(){super(...arguments),this.textContent="",this.textSort="",this.textFilter="",this.textFilterCounter="",this.textFiltersCounter="",this.textDataSeeResult="",this.textDataSeeResults="",this.textFrom="",this.textTo="",this.textHideCount="",this.textViewAllCount="",this.textApply="",this.textNoOptionsMatchSearch="",this.textClearAll="",this.dataResultsGridWithCountOne="",this.dataResultsGridWithCountOther="",this.resultsPerPage=36,this.collectionHandle="",this.collectionsData={},this.facetsCheckboxVisibleLimit=8,this.currentPage=1,this.enableBundle=!1,this.textFilterResults="",this._constructorResponseID=0,this._skipUrlUpdate=!1,this._facetSearchQuery={}}async connectedCallback(){super.connectedCallback();const e=new URLSearchParams(window.location.search);this.currentPage=Number(e.get("page"))||1,this._skipUrlUpdate=!0,this.fetchProducts(),window.addEventListener("popstate",this.onPopState.bind(this)),await this.updateComplete,this._skipUrlUpdate=!1}disconnectedCallback(){window.removeEventListener("popstate",this.onPopState.bind(this)),super.disconnectedCallback()}async onPopState(){this._skipUrlUpdate=!0;try{const e=new URLSearchParams(window.location.search),t=Number(e.get("page"))||1;t!==this.currentPage&&(this.currentPage=t),await this.fetchProducts()}finally{this._skipUrlUpdate=!1}}async fetchProducts(){try{const e=await this.getPaginatedResults(this.currentPage);if(e){const{results:t,totalPages:s,facets:r,sortOptions:a,totalResults:d}=e;if(!t)return;const i=t&&t.length>0?t.map(u=>{var c,g;return(c=u.data)!=null&&c.handle?{handle:(g=u.data)==null?void 0:g.handle}:{}}):[];this.collectionsData={facets:r,sortOptions:a,cards:i,paginationIds:Array.from({length:s},(u,c)=>c+1),totalResults:d};const p=r==null?void 0:r.find(u=>this.hasName(u)&&u.name==="price");p&&(this._productsMaxPrice=p.max);const o=this.getTotalFiltersApplied(this.collectionsData.facets);this.textFilterResults=o==0?this.textFilter:o>1?this.textFiltersCounter:this.textFilterCounter,o>0&&(this.textFilterResults=this.textFilterResults.replace("{{ count }}",String(o)))}}catch(e){console.error("Error fetching browse results:",e)}}hasName(e){return typeof e=="object"&&e!==null&&"name"in e}createSearchParams(e,t){const s={...e,...t&&{sort_by:t}},r=new URLSearchParams;for(const[a,d]of Object.entries(s))Array.isArray(d)?d.forEach(i=>r.append(`filter_${a}`,i)):r.append(`filter_${a}`,d);return r.toString()}updateURLHash(e){if(this._skipUrlUpdate)return;const t=new URLSearchParams(e);this.currentPage>1?t.set("page",this.currentPage.toString()):t.delete("page");const s=t.toString();history.pushState({processedParams:s},"",`${window.location.pathname}${s&&"?".concat(s)}`)}isEmptyObj(e){return Object.keys(e).length===0&&e.constructor===Object}async getPaginatedResults(e=1,t=this.resultsPerPage,s={},r=""){let a={...s},d=r;if(r==""&&this.isEmptyObj(s)){const i=new URLSearchParams(window.location.search),p={};for(const[c,g]of i.entries()){if(!c.startsWith("filter_"))continue;const x=c.replace(/^filter_/,""),v=p[x];v===void 0?p[x]=x==="price"?[g]:g:Array.isArray(v)?v.push(g):p[x]=[v,g]}const{sort_by:o,...u}=p;d=Array.isArray(o)?o[0]:o||"",a={...u}}this.isEmptyObj(s)&&r=="relevance"&&(d=""),this.updateURLHash(this.createSearchParams(a,d));try{const i=await O.browse({filterName:"group_id",filterValue:this.collectionHandle,section:"Products",page:e,resultsPerPage:t,filters:a,sortBy:d,sortOrder:d.includes("ascending")?"ascending":"descending"},{enabled:!0,expiryMs:12e4});if(!i.response)return;const p=i.response.results,o=i.response.total_num_results,u=Math.ceil((o??1)/this.resultsPerPage),c=i.response.sort_options,g=i.response.facets;return{results:p,totalPages:u,currentPage:e,facets:g,sortOptions:c,totalResults:o}}catch(i){return console.error("Constructor.io pagination error:",i),null}}async filterChanged(e,t){var v;if(!e)return;const s=t==null?void 0:t.hasAttribute("target-clear-all-filters"),r=(t==null?void 0:t.tagName)==="FACET-REMOVE"&&t.dataset.name=="price";if(t)if(t.id.toLowerCase().includes("mobile")){if(t.getAttribute("type")==="radio"){const n=document.querySelector('select[name="sort_by"]');n&&(n.value=t.value,n.dispatchEvent(new Event("change",{bubbles:!0})))}else{const n=t.id.replace("Mobile","Desktop"),f=document.getElementById(n);f&&(f.getAttribute("type")==="checkbox"?f.checked=t.checked:f.value=t.value,f.dispatchEvent(new Event("change",{bubbles:!0})))}return}else if(t.tagName.toLowerCase()==="select"){const n=document.querySelector(`[type="radio"][name="sort_by"][value="${t.value}"]`);n.checked=!0}else{const n=document.getElementById(t.id.replace("Desktop","Mobile"));n&&(t.type=="checkbox"?n.checked=t.checked:n.value=t.value)}const a=(v=e.querySelector("#SortOptionsFormDesktop select"))==null?void 0:v.value;let d=1;const i=e.querySelector("[aria-current='page']");i&&!t&&i.textContent&&(d=parseFloat(i.textContent));const p=parseFloat(e.getAttribute("data-pagination-results-per-page")),o=e.querySelector("[target-filters]"),u=new FormData(o),c={};for(const[n,f]of u.entries())c[n]?Array.isArray(c[n])?c[n].push(f):c[n]=[c[n],f]:c[n]=f;const g={};if(!s){const n=o.querySelector('[name="filter.v.price.gte"]'),f=n?n.getAttribute("data-min")||n.getAttribute("min"):null,_=n?n.getAttribute("data-max")||n.getAttribute("max"):null;let C,S;for(const[k,F]of Object.entries(c))k==="filter.v.price.gte"?typeof F=="string"&&(C=F):k==="filter.v.price.lte"?typeof F=="string"&&(S=F):k!=="sort_by"&&(g[k]=F);if((C&&f&&parseFloat(C)!=parseFloat(f)||S&&_&&parseFloat(S)!=parseFloat(_))&&!r){const k=C??"",F=S??"";g.price=[`${k}-${F}`]}}this.scrollIntoView();const x=await this.getPaginatedResults(d,p,g,a);if(this._constructorResponseID++,x){const{results:n,totalPages:f,facets:_,sortOptions:C,totalResults:S}=x;if(!n)return;const k=_==null?void 0:_.map($=>({...$,opened:"status"in $&&typeof $.status=="object"&&Object.keys($.status).length>0||"options"in $&&Array.isArray($.options)&&$.options.some(P=>P.status!=="")})),F=n&&n.length>0?n.map($=>{var P,D;return(P=$.data)!=null&&P.handle?{handle:(D=$.data)==null?void 0:D.handle}:{}}):[];this.collectionsData={facets:k,sortOptions:C,cards:F,paginationIds:Array.from({length:f},($,P)=>P+1),totalResults:S};const R=this.getTotalFiltersApplied(this.collectionsData.facets);this.textFilterResults=R==0?this.textFilter:R>1?this.textFiltersCounter:this.textFilterCounter,R>0&&(this.textFilterResults=this.textFilterResults.replace("{{ count }}",String(R))),this.scrollIntoView({behavior:"smooth",block:"start"})}}paginateHandleClick(e){var a,d;const t=e.target,s=(d=(a=t.parentElement)==null?void 0:a.parentElement)==null?void 0:d.querySelectorAll("button:not([data-direction])"),r=parseInt(t==null?void 0:t.textContent);this.currentPage=r,s==null||s.forEach(i=>{var u;const o=parseInt((u=i.querySelector("span"))==null?void 0:u.textContent)==r;i.classList.toggle("border-t-foreground",o),i.classList.toggle("border-t-border",!o),o?(i.setAttribute("aria-current","page"),this.filterChanged(t.closest("collection-results-section"))):i.removeAttribute("aria-current")})}paginateArrowClick(e){var a,d,i,p;const t=e.target,s=(d=(a=t.parentElement)==null?void 0:a.parentElement)==null?void 0:d.querySelector("[aria-current='page']"),r=(p=(i=t.parentElement)==null?void 0:i.parentElement)==null?void 0:p.querySelectorAll("button:not([data-direction])");if(s&&r&&t){const o=Array.from(r).indexOf(s),u=parseFloat(t==null?void 0:t.getAttribute("data-direction"));u>0&&o<r.length-1&&r[o+1].click(),u<0&&o>0&&r[o-1].click()}}applyFilterEvent(e){const t=e.target;this.currentPage=1,this.filterChanged(t.closest("collection-results-section"),t)}clearAllFilters(e){e.preventDefault(),this.applyFilterEvent(e)}handleSelectChange(e){this.applyFilterEvent(e)}handleCheckboxChange(e){this.applyFilterEvent(e)}handleInputChange(e){const t=e.target,s=t.name==="filter.v.price.gte"||t.name==="filter.v.price.lte";e.type==="input"&&s||this.applyFilterEvent(e)}handleize(e){return e.toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-$/,"").replace(/^-/,"")}getFacetSearchKey(e,t="Desktop"){return`${e}-${t}`}getFacetSearchValue(e,t="Desktop"){return this._facetSearchQuery[this.getFacetSearchKey(e,t)]??""}handleFacetSearchInput(e,t,s="Desktop"){const r=e.target,a=this.getFacetSearchKey(t,s);this._facetSearchQuery={...this._facetSearchQuery,[a]:r.value},this.requestUpdate()}getFilteredFacetOptions(e=[],t=""){if(!t.trim())return e;const s=t.toLowerCase();return e.filter(r=>r.display_name.toLowerCase().includes(s))}getTotalFiltersApplied(e){return(e==null?void 0:e.reduce((t,s)=>{const r=s.type!="range"?s.options.filter(a=>a.status==="selected").length:Object.hasOwn(s.status,"min")&&Object.hasOwn(s.status,"max")&&(s.status.min!=s.min||s.status.max<(this._productsMaxPrice||s.max))?1:0;return t+r},0))||0}getFacetsHTML(e,t,s){var d,i,p;const r=this.getTotalFiltersApplied(e),a=r==0?this.textApply.replace("{{ count }}","0"):(((d=this.collectionsData)==null?void 0:d.totalResults)??0)>1?this.textDataSeeResults:this.textDataSeeResult;return l`
      <div class="flex h-full w-full flex-col">
        <div
          class="flex-grow${t=="Mobile"?" overflow-auto":y}"
        >
          ${w(e??[],o=>o.name+t+this._constructorResponseID,o=>l`
              <details
                class="group/details border-b border-t-border"
                ?open="${t!="Mobile"||o.opened||o.type==="range"}"
              >
                <summary
                  class='focus-inset group/filter-dropdown md:after:content-[" "] relative flow-root cursor-pointer max-md:px-xs max-md:py-md md:pointer-events-none md:cursor-auto md:pb-xs md:pt-sm md:after:pointer-events-none md:after:absolute md:after:left-0 md:after:top-0 md:after:z-10 md:after:block md:after:h-full md:after:w-full'
                >
                  <div class="flex w-full items-center justify-between text-sm">
                    <span
                      class="${window.brand=="NG"?"text-t-foreground-secondary font-normal":"font-medium"} text-heading-6 capitalize"
                      >${o.display_name}</span
                    >
                    <span class="hidden group-open/details:block">
                      <svg-icon
                        src="icon-minus"
                        class="block md:hidden"
                        style="--icon-size: 13px;"
                      ></svg-icon>
                    </span>
                    <span class="block group-open/details:hidden">
                      <svg-icon
                        src="icon-plus"
                        class="block md:hidden"
                        style="--icon-size: 13px;"
                      ></svg-icon>
                    </span>
                  </div>
                </summary>
                ${(()=>{const u=o.display_name.toLowerCase();switch(!0){case u.includes("price"):return l`
                        ${o.type==="range"?l`
                              <div
                                class="group/facet max-md:px-xs max-md:pb-md md:pb-sm"
                              >
                                <price-range-slider class="block max-w-[258px]">
                                  <div
                                    class="slider-track relative mx-auto h-1 w-[95%] cursor-pointer rounded-full bg-t-disabled"
                                    data-slider-track
                                  >
                                    <!-- Active track area -->
                                    <div
                                      class="active-track absolute h-1 rounded-full bg-t-accent-01"
                                      data-active-track
                                      style="left: 0%; width: 100%;"
                                    ></div>

                                    <!-- Handles -->
                                    <div
                                      class="min-handle absolute -ml-2.5 -mt-2 h-5 w-5 cursor-grab rounded-full border-2 border-t-foreground bg-t-background shadow-md"
                                      data-min-handle
                                      style="left: 0%;"
                                    ></div>
                                    <div
                                      class="max-handle absolute -ml-2.5 -mt-2 h-5 w-5 cursor-grab rounded-full border-2 border-t-foreground bg-t-background shadow-md"
                                      data-max-handle
                                      style="left: 100%;"
                                    ></div>
                                  </div>

                                  <div class="mt-5 flex items-center gap-3">
                                    <div class="relative flex">
                                      <span
                                        class="field-currency text-body absolute left-2.5 top-2.5 z-10"
                                        >$</span
                                      >
                                      <div class="group flex flex-col gap-2xs">
                                        <div class="group peer relative w-full">
                                          <input
                                            class="body bg-gray-50 remove-arrow peer text-body block h-sm-forms-inputheight w-full appearance-none border border-t-foreground-secondary bg-t-background px-sm-forms-padding py-2.5 !pl-5 pt-sm-forms-padding text-t-foreground rounded-forms-radius group-[[error]]:border-[transparent] group-[[error]]:ring-2 group-[[error]]:ring-u-error focus:border-t-foreground focus:outline-none focus:ring-0 disabled:border-t-border disabled:text-t-border lg:h-lg-forms-inputheight lg:px-lg-forms-padding lg:pt-lg-forms-padding"
                                            placeholder=" "
                                            type="number"
                                            id="${t}-Filter-Price-GTE"
                                            name="filter.v.price.gte"
                                            value="${z(o.status.min)}"
                                            data-pattern="d| |,|."
                                            min="0"
                                            max="${A(this._productsMaxPrice)}"
                                            data-max="${A(this._productsMaxPrice)}"
                                            inputmode="decimal"
                                            @input=${this.handleInputChange}
                                            @change=${this.handleInputChange}
                                          />
                                          <label
                                            for="${t}-Filter-Price-GTE"
                                            class="caption absolute start-sm-forms-padding top-3.5 z-10 hidden origin-[0] -translate-y-2.5 scale-75 transform text-t-foreground-secondary duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:-translate-y-2.5 peer-focus:scale-75 peer-focus:text-t-foreground peer-disabled:text-t-border lg:start-sm-forms-padding rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                                          >
                                            ${this.textFrom}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <span
                                      class="text-utility-regular text-t-foreground"
                                      >to</span
                                    >
                                    <div class="relative flex">
                                      <span
                                        class="field-currency text-body absolute left-2.5 top-2.5 z-10"
                                        >$</span
                                      >
                                      <div class="group flex flex-col gap-2xs">
                                        <div class="group peer relative w-full">
                                          <input
                                            class="body bg-gray-50 remove-arrow peer text-body block h-sm-forms-inputheight w-full appearance-none border border-t-foreground-secondary bg-t-background px-sm-forms-padding py-2.5 !pl-5 pt-sm-forms-padding text-t-foreground rounded-forms-radius group-[[error]]:border-[transparent] group-[[error]]:ring-2 group-[[error]]:ring-u-error focus:border-t-foreground focus:outline-none focus:ring-0 disabled:border-t-border disabled:text-t-border lg:h-lg-forms-inputheight lg:px-lg-forms-padding lg:pt-lg-forms-padding"
                                            placeholder=" "
                                            type="number"
                                            id="${t}-Filter-Price-LTE"
                                            name="filter.v.price.lte"
                                            value="${A(o.status.max)}"
                                            data-pattern="d| |,|."
                                            min="0"
                                            max="${A(this._productsMaxPrice)}"
                                            data-max="${A(this._productsMaxPrice)}"
                                            inputmode="decimal"
                                            @input=${this.handleInputChange}
                                            @change=${this.handleInputChange}
                                          />
                                          <label
                                            for="${t}-Filter-Price-LTE"
                                            class="caption absolute start-sm-forms-padding top-3.5 z-10 hidden origin-[0] -translate-y-2.5 scale-75 transform text-t-foreground-secondary duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:-translate-y-2.5 peer-focus:scale-75 peer-focus:text-t-foreground peer-disabled:text-t-border lg:start-sm-forms-padding rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                                          >
                                            ${this.textTo}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </price-range-slider>
                              </div>
                            `:y}
                      `;case u.includes("color"):return l`
                        ${o.type==="multiple"?l`
                              <div
                                id="FacetFiltersForm${t}_details-content_filter.p.m.custom.color_group"
                                sub-section-id="FacetFiltersForm${t}_details-content_filter.p.m.custom.color_group"
                                class="group/facet max-md:px-xs max-md:pb-md md:pb-sm"
                              >
                                <ul
                                  class="list-unstyled space-y-xs md:space-y-2xs"
                                  role="list"
                                >
                                  ${w(o.options,c=>c.value+t,(c,g)=>l`
                                      <li class="py-2xs">
                                        <div class="group/swatch">
                                          <input
                                            type="checkbox"
                                            id="FacetFiltersForm${t}_input_filter.p.m.custom.color_group${g}"
                                            name="${o.name}"
                                            value="${c.value}"
                                            class="sr-only"
                                            .checked=${c.status!=""}
                                            @change=${this.handleCheckboxChange}
                                          />
                                          <label
                                            for="FacetFiltersForm${t}_input_filter.p.m.custom.color_group${g}"
                                            title="gid://shopify/Metaobject/103948976181"
                                            class="text-body flex cursor-pointer items-center gap-x-xs"
                                          >
                                            <span
                                              class="relative block aspect-square max-h-[18px] w-[var(--swatch--size,_2rem)] max-w-[18px] overflow-clip rounded-full border border-solid border-t-border bg-[--swatch--background] bg-cover bg-[position:var(--swatch-focal-point,_initial)] bg-origin-border ring-t-foreground ring-offset-2 transition duration-300 ease-in-out [background-image:var(--swatch--background)] group-focus-within/swatch:ring-2 group-focus-within/swatch:ring-[--swatch--background] group-focus-within/swatch:ring-opacity-50 group-focus-within/swatch:ring-offset-2 group-has-[:disabled]/swatch:opacity-30 group-has-[:checked]/swatch:ring-1"
                                              style="--swatch--background: var(--swatch-${this.handleize(c.display_name)});"
                                            ></span>
                                            <span
                                              class="group-has-[:disabled]/swatch:text-t-disabled"
                                            >
                                              <span aria-hidden="true">
                                                <span class="capitalize"
                                                  >${c.display_name}</span
                                                >
                                              </span>
                                              <span class="sr-only"
                                                >${c.display_name}</span
                                              >
                                            </span>
                                          </label>
                                        </div>
                                      </li>
                                    `)}
                                </ul>
                              </div>
                            `:y}
                      `;case u.includes("review"):return l`
                        ${o.type==="multiple"?l`
                              <div
                                id="FacetFiltersForm${t}_details-content_filter.p.m.custom.rating_tier"
                                sub-section-id="FacetFiltersForm${t}_details-content_filter.p.m.custom.rating_tier"
                                class="group/facet max-md:px-xs max-md:pb-md md:pb-sm"
                              >
                                <ul
                                  class="list-unstyled flex flex-col-reverse gap-y-xs md:gap-y-2xs"
                                  role="list"
                                >
                                  ${w(o.options,c=>c.value+t,(c,g)=>l` <li>
                                        <div
                                          class="group/checkbox inline-flex h-[1.813rem] items-center gap-x-xs"
                                        >
                                          <label
                                            class="relative flex cursor-pointer items-center overflow-clip rounded-[1px]"
                                            for="FacetFiltersForm${t}_input_filter.p.m.custom.rating_tier${g}"
                                          >
                                            <input
                                              type="checkbox"
                                              class="${window.brand=="NG"?"rounded-[2px] border-t-foreground-secondary":"border-blue-gray-200"} peer relative size-4 cursor-pointer appearance-none border transition-all checked:border-t-foreground disabled:border-t-border"
                                              id="FacetFiltersForm${t}_input_filter.p.m.custom.rating_tier${g}"
                                              value="${c.value}"
                                              name="rating_tier"
                                              aria-labelledby="FacetFiltersForm${t}_input_filter.p.m.custom.rating_tier${g}_label"
                                              .checked=${c.status!=""}
                                              @change=${this.handleCheckboxChange}
                                            />
                                            <span
                                              class="${window.brand=="NG"?"bg-t-foreground-secondary":"bg-p-darkest"} pointer-events-none absolute left-2/4 top-2/4 flex size-3 h-full w-full -translate-x-2/4 -translate-y-2/4 items-center justify-center text-p-lightest opacity-0 transition-opacity peer-checked:opacity-100 peer-disabled:border-t-border peer-disabled:text-t-border"
                                            >
                                              <svg-icon
                                                src="icon-checkbox-tick"
                                                class="block"
                                                style="--icon-size: 12px;"
                                              ></svg-icon>
                                            </span>
                                          </label>
                                          <label
                                            class="text-body mt-px cursor-pointer select-none text-t-foreground group-has-[:disabled]/checkbox:pointer-events-none group-has-[:disabled]/checkbox:text-t-border"
                                            for="FacetFiltersForm${t}_input_filter.p.m.custom.rating_tier${g}"
                                          >
                                            <div>
                                              <p
                                                id="FacetFiltersForm${t}_input_filter.p.m.custom.rating_tier${g}_label"
                                                class="text-body block leading-none text-t-foreground group-has-[:disabled]/checkbox:text-t-disabled"
                                              >
                                                <span aria-hidden="true">
                                                </span>
                                              </p>
                                              <div
                                                class="flex items-center gap-xs group-has-[:disabled]/checkbox:opacity-50"
                                              >
                                                <div
                                                  class="${window.brand=="TFC"?"gap-[0.063rem]":"gap-1"} flex items-center"
                                                >
                                                  ${w([1,2,3,4,5],x=>"star"+x+t,x=>x<=parseFloat(c.value)?l`<svg-icon
                                                            src="icon-star-full"
                                                            class="block text-t-accent-01"
                                                            style="--icon-size: 16px;"
                                                          ></svg-icon>`:l`<svg-icon
                                                            src="icon-star-empty"
                                                            class="${window.brand=="NG"?"text-t-disabled":"text-t-foreground-secondary"} block"
                                                            style="--icon-size: 16px;"
                                                          ></svg-icon>`)}
                                                </div>
                                              </div>

                                              <span class="sr-only"
                                                >${c.value}
                                              </span>
                                              <p></p>
                                            </div>
                                          </label>
                                        </div>
                                      </li>`)}
                                </ul>
                              </div>
                            `:y}
                      `;default:return l`
                        ${o.type==="multiple"?l`
                              <div
                                class="group/facet max-md:px-xs max-md:pb-md md:pb-sm"
                              >
                                ${(()=>{const c=o.options.length>20,g=c?this.getFacetSearchValue(o.name,t):"",x=c?this.getFilteredFacetOptions(o.options,g):o.options,v=x.length>this.facetsCheckboxVisibleLimit;return l`
                                    ${c?l`
                                          <div class="mb-sm">
                                            <label
                                              class="sr-only"
                                              for="Filter-filter.p.${this.handleize(o.name)}-${t}-search"
                                              >Search
                                              ${o.display_name}</label
                                            >
                                            <div class="relative">
                                              <input
                                                type="search"
                                                class="${window.brand!=="TFC"?"rounded-[0.375rem] bg-transparent":""} text-body w-full border border-t-border px-xs py-[0.625rem] pr-[2.75rem] text-t-foreground-secondary outline-none focus:border-t-foreground [&::-webkit-search-cancel-button]:appearance-none"
                                                id="Filter-filter.p.${this.handleize(o.name)}-${t}-search"
                                                placeholder="Search ${o.display_name}"
                                                .value=${g}
                                                @input=${n=>this.handleFacetSearchInput(n,o.name,t)}
                                              />
                                              <span
                                                class="${window.brand!=="TFC"?"border-l border-t-border":""} pointer-events-none absolute right-px top-px flex h-[calc(100%-2px)] w-10 items-center justify-center"
                                              >
                                                <svg-icon
                                                  src="icon-search"
                                                  class="block"
                                                  style="--icon-size: 18px;"
                                                ></svg-icon>
                                              </span>
                                            </div>
                                          </div>
                                        `:y}
                                    ${x.length>0?l`
                                          <ul
                                            class="list-unstyled space-y-2xs"
                                            role="list"
                                          >
                                            ${w(x,n=>n.value,(n,f)=>l` <li
                                                  class=${f>=this.facetsCheckboxVisibleLimit&&v?'group-has-[toggle-button[data-toggled="false"]]/facet:hidden':""}
                                                >
                                                  <div
                                                    class="group/checkbox inline-flex items-center justify-start gap-x-xs"
                                                  >
                                                    <label
                                                      class="relative flex cursor-pointer items-center overflow-clip rounded-[1px]"
                                                      for="Filter-filter.p.${this.handleize(n.display_name)}-${t}-${f}"
                                                    >
                                                      <input
                                                        type="checkbox"
                                                        class="${window.brand=="NG"?"rounded-[2px] border-t-foreground-secondary":"border-blue-gray-200"} peer relative size-4 cursor-pointer appearance-none border transition-all checked:border-t-foreground disabled:border-t-border"
                                                        id="Filter-filter.p.${this.handleize(n.display_name)}-${t}-${f}"
                                                        value="${n.value}"
                                                        name="${o.name}"
                                                        aria-labelledby="Filter-filter.p.${this.handleize(n.display_name)}-${t}-${f}_label"
                                                        .checked=${n.status!==""}
                                                        @change=${this.handleCheckboxChange}
                                                      />
                                                      <span
                                                        class="${window.brand=="NG"?"bg-t-foreground-secondary":"bg-p-darkest"} pointer-events-none absolute left-2/4 top-2/4 flex size-3 h-full w-full -translate-x-2/4 -translate-y-2/4 items-center justify-center text-p-lightest opacity-0 transition-opacity peer-checked:opacity-100 peer-disabled:border-t-border peer-disabled:text-t-border"
                                                      >
                                                        <svg-icon
                                                          src="icon-checkbox-tick"
                                                          class="block"
                                                          style="--icon-size: 12px;"
                                                        ></svg-icon>
                                                      </span>
                                                    </label>
                                                    <label
                                                      class="text-body mt-px cursor-pointer select-none text-balance capitalize text-t-foreground group-has-[:disabled]/checkbox:text-t-border"
                                                      for="Filter-filter.p.${this.handleize(n.display_name)}-${t}-${f}"
                                                    >
                                                      ${n.display_name}
                                                    </label>
                                                  </div>
                                                </li>`)}
                                          </ul>
                                        `:l`
                                          <p
                                            class="text-body mt-xs text-t-foreground"
                                          >
                                            ${this.textNoOptionsMatchSearch}
                                          </p>
                                        `}
                                    ${v?l`
                                          <toggle-button
                                            role="button"
                                            data-toggled="false"
                                            class="group/toggle-button ${window.brand=="NG"?"text-t-foreground-secondary font-bold":"text-t-foreground"} text-utility-bold mt-md underline md:mt-xs"
                                          >
                                            <span
                                              class='group-data-[toggled="true"]/toggle-button:hidden'
                                              >${this.textViewAllCount.replace("{{ count }}",`${x.length}`)}</span
                                            >
                                            <span
                                              class='group-data-[toggled="false"]/toggle-button:hidden'
                                              >${this.textHideCount.replace("{{ count }}",`${x.length-this.facetsCheckboxVisibleLimit}`)}</span
                                            >
                                          </toggle-button>
                                        `:y}
                                  `})()}
                              </div>
                            `:y}
                      `}})()}
              </details>
            `)}
        </div>
        ${t=="Mobile"?l`
              <div
                class="group/toggle-clear-all flex w-full flex-col items-center justify-center gap-xs border-t border-t-border bg-t-background px-pagegridmargin py-sm"
                data-show-clear-all=${(r??0)>0}
              >
                <dialog-toggle modal-id="${s}" class="w-full">
                  <button class="btn w-full" variant="primary">
                    ${(a==null?void 0:a.replace("{{ count }}",((p=(i=this.collectionsData)==null?void 0:i.totalResults)==null?void 0:p.toString())??""))??""}
                  </button>
                </dialog-toggle>
                <button
                  class='text-utility-bold block cursor-pointer text-t-foreground underline group-data-[show-clear-all="false"]/toggle-clear-all:hidden'
                  target-clear-all-filters
                  @click=${this.clearAllFilters}
                >
                  ${this.textClearAll}
                </button>
              </div>
            `:y}
      </div>
    `}getSortHTML(e,t){return l`
      ${t=="Desktop"?l` <facet-filters-form
            section-id="facet-filters"
            data-mode="sort"
            class="max-md:hidden"
          >
            <form
              id="SortOptionsForm${t}"
              class="gap-2xs${window.brand=="TFC"?" !font-normal":""} text-utility-bold flex"
            >
              <label for="SortBy">${this.textSort}:</label>
              <div class="relative">
                <select
                  name="sort_by"
                  id="SortBy"
                  class="outline-none${window.brand=="TFC"?" bg-transparent":""} block w-full appearance-none pr-sm"
                  @change=${this.handleSelectChange}
                >
                  ${w(e??[],s=>s.sort_by+t+this._constructorResponseID,s=>l`
                      <option
                        value="${s.sort_by}"
                        ?selected=${s.status!=""}
                      >
                        ${s.display_name.replace("Most Relevant","Featured")}
                      </option>
                    `)}
                </select>
                <svg-icon
                  src="icon-select-arrow"
                  class="pointer-events-none absolute right-0 top-2/4 -translate-y-2/4"
                  style="--icon-size: 16px;"
                ></svg-icon>
              </div>
            </form>
          </facet-filters-form>`:l` <facet-filters-form
            section-id="facet-filters"
            data-mode="sort"
            class="flex h-full"
          >
            <form
              id="SortOptionsForm${t}"
              class="flex w-full flex-col"
            >
              <div
                id="SortOptionsForm${t}_sort"
                class="group/facet max-md:px-pagegridmargin max-md:py-md md:pb-sm"
                sub-section-id="SortOptionsForm${t}_sort"
                data-sort-by="title-ascending"
              >
                <ul class="list-unstyled space-y-xs md:space-y-2xs" role="list">
                  ${w(e??[],s=>s.sort_by+t,s=>l`
                      <li class="py-2xs" data-selected="false">
                        <div
                          class="group/radio flex w-full min-w-0 items-start justify-start gap-x-xs"
                        >
                          <div
                            class="peer relative flex shrink-0 cursor-pointer items-center rounded-full"
                          >
                            <input
                              type="radio"
                              class="peer relative size-4 cursor-pointer appearance-none rounded-full border border-t-foreground-secondary text-t-foreground-secondary transition-all checked:border-t-foreground-secondary disabled:border-t-border"
                              id="sortoptionsform${t}_input_${s.sort_by}"
                              name="sort_by"
                              value="${s.sort_by}"
                              @change=${this.handleSelectChange}
                              .checked=${s.status!=""}
                            />
                            <span
                              class="pointer-events-none absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-2/4 scale-0 text-t-foreground opacity-0 transition-[opacity,transform-] peer-checked:scale-100 peer-checked:opacity-100"
                            >
                              <svg-icon
                                src="icon-radio-circle"
                                class="block"
                                style="--icon-size: 10px;"
                              ></svg-icon>
                            </span>
                          </div>
                          <label
                            class="mt-px flex-1 cursor-pointer select-none"
                            for="sortoptionsform${t}_input_${s.sort_by}"
                          >
                            <div>
                              <p
                                id="sortoptionsform${t}_input_${s.sort_by}_label"
                                class="text-body block leading-none text-t-foreground group-has-[:disabled]/radio:text-t-disabled"
                              >
                                ${s.display_name.replace("Most Relevant","Featured")}
                              </p>
                            </div>
                          </label>
                        </div>
                      </li>
                    `)}
                </ul>
              </div>
            </form>
          </facet-filters-form>`}
    `}getPaginationArray(e,t){const r=[];if(r.push("1"),t<=6)for(let a=2;a<t;a++)r.push(a);else if(e<=3){for(let a=2;a<=4;a++)r.push(a);r.push("...")}else if(e>=t-2){r.push("...");for(let a=t-3;a<t;a++)r.push(a)}else r.push("..."),r.push(e-1),r.push(e),r.push(e+1),r.push("...");return r[r.length-1]!==t&&r.push(t),r.map(a=>a.toString())}getPaginateHTML(e,t=1){if(!e)return;const s=this.getPaginationArray(t,e.length);if(s)return l`
      ${(e==null?void 0:e.length)>1?l`
            <div class="flex justify-center px-lg pb-lg pt-md">
              <ul
                class="flex list-none items-center justify-center gap-2.5"
                role="list"
              >
                ${(e==null?void 0:e.length)>1?l`
                      <li class="inline-flex list-none">
                        <button
                          class="${t===1?"cursor-not-allowed opacity-40":""} flex h-11 items-center justify-center"
                          data-direction="-1"
                          ?disabled=${t===1}
                          aria-disabled="${t===1}"
                          @click=${this.paginateArrowClick}
                        >
                          <svg-icon
                            src=${window.brand==="TFC"?"icon-arrow-curved":"icon-caret"}
                            class="block${window.brand==="TFC"?" text-t-accent-01":""} pointer-events-none"
                            style="--icon-size: 16px;${window.brand==="TFC"?"":" rotate: 90deg;"}"
                          ></svg-icon>
                        </button>
                      </li>
                    `:y}
                ${w(s,r=>"productPage"+r,r=>l`
                    ${r!="..."?l`
                          <li class="inline-flex list-none">
                            <button
                              class="${r==t.toString()?`${window.brand=="NG"?"border-t-foreground-secondary bg-t-accent-04":"border-t-foreground"}`:"border-t-border"} ${window.brand=="NG"?"rounded-full":"rounded-sm"} flex h-11 w-11 items-center justify-center border"
                              aria-current="${r==t.toString()?"page":y}"
                              @click=${this.paginateHandleClick}
                            >
                              <span class="utility-standard pointer-events-none"
                                >${r}</span
                              >
                            </button>
                          </li>
                        `:l`
                          <li class="inline-flex list-none">
                            <span
                              class="${window.brand=="NG"?"rounded-full":"rounded-sm"} flex h-11 w-11 items-center justify-center border border-t-border"
                            >
                              <span class="utility-standard pointer-events-none"
                                >…</span
                              >
                            </span>
                          </li>
                        `}
                  `)}
                ${(e==null?void 0:e.length)>1?l`
                      <li class="inline-flex list-none">
                        <button
                          class="${t===e.length?"cursor-not-allowed opacity-40":""} flex h-11 items-center justify-center"
                          data-direction="1"
                          ?disabled=${t===e.length}
                          aria-disabled="${t===e.length}"
                          @click=${this.paginateArrowClick}
                        >
                          <svg-icon
                            src=${window.brand==="TFC"?"icon-arrow-curved":"icon-caret"}
                            class="block${window.brand==="TFC"?" text-t-accent-01":""} pointer-events-none"
                            style="--icon-size: 16px;${window.brand==="TFC"?" rotate: 180deg;":" rotate: -90deg;"}"
                          ></svg-icon>
                        </button>
                      </li>
                    `:y}
              </ul>
            </div>
          `:y}
    `}removeFacet(e){const t=e.target;if(t.dataset.name=="price")this.currentPage=1,this.filterChanged(t.closest("collection-results-section"),t);else{const s=this.querySelector(`[target-filters][is-mobile] [name="${t.dataset.name}"][value="${t.dataset.value}"]`);s&&s.click()}}getFacetRemove(e,t){return l`
      <facet-remove
        class="flex cursor-pointer snap-center items-center gap-2xs whitespace-nowrap rounded-sm bg-t-background-secondary px-xs py-[0.438rem]"
        data-name="${e.name}"
        data-value="${e.display_name}"
        @click=${this.removeFacet}
      >
        <svg-icon
          src="icon-close"
          class="pointer-events-none block"
          style="--icon-size: 8px"
        ></svg-icon>
        <span
          class="text-utility-regular pointer-events-none text-t-foreground"
        >
          ${e.type=="range"?l`$${z(e.min)} -
              $${A(e.max)}`:e.name=="rating_tier"?l`
                  <div class="flex items-center gap-1">
                    ${w([1,2,3,4,5],s=>"star"+s+t,s=>s<=parseFloat(e.display_name)?l`<svg-icon
                              src="icon-star-full"
                              class="block text-t-accent-01"
                              style="--icon-size: 16px;"
                            ></svg-icon>`:l`<svg-icon
                              src="icon-star-empty"
                              class="block text-t-foreground-secondary"
                              style="--icon-size: 16px;"
                            ></svg-icon>`)}
                  </div>
                `:l`${e.display_name}`}
        </span>
      </facet-remove>
    `}getFilteredFacets(e,t){if(!(e!=null&&e.length))return l``;const s=(e==null?void 0:e.reduce((r,a)=>{if(a.type!=="range"){const d=a.options.filter(i=>i.status==="selected").map(i=>({...i,name:a.name}));return r.concat(d)}else{const d=Object.hasOwn(a.status,"min")&&Object.hasOwn(a.status,"max"),i=a.status.min!==a.min,p=a.status.max<(this._productsMaxPrice??a.max);return d&&(i||p)&&r.push({...a,min:a.status.min,max:a.status.max}),r}},[]))??[];return l`
      <div
        class="empty:pt-0${t=="Desktop"?" max-md:hidden":""} col-span-full w-full pt-sm empty:hidden"
        data-target-facet-removes="${t==null?void 0:t.toLowerCase()}"
      >
        ${s.length>0?l` <facet-filters-form
              section-id="facet-filters"
              class="[&amp;[loading]]:opacity-50 [&amp;[loading]]:pointer-events-none flex h-full w-full"
              data-mode="facet-removes"
              data-form-id="FacetRemovesForm${t}"
              data-filters-form-id="FacetFiltersForm${t}"
            >
              <form
                id="FacetRemovesForm${t}"
                class="${t=="Desktop"?"flex-wrap":"no-scrollbar overflow-x-auto snap-x snap-mandatory px-xs"} flex w-full items-center gap-2xs"
              >
                ${w(s??[],r=>r.name,r=>this.getFacetRemove(r,t))}
                ${t=="Desktop"?l`<facet-remove
                      class="text-utility-bold ml-2xs cursor-pointer text-t-foreground underline"
                      target-clear-all-filters
                      @click=${this.clearAllFilters}
                    >
                      ${this.textClearAll}
                    </facet-remove>`:y}
              </form>
            </facet-filters-form>`:y}
      </div>
    `}getModalDialog(e,t,s,r,a,d,i,p,o,u){return l`
      <modal-dialog
        cloak
        type="${a}"
        id="${e}"
        anchor="${t}"
        close-on-backdrop-click="true"
        drawer-classes="${o}"
        header-classes="${u}"
        close-icon-size="${i}"
      >
        <h5 slot="header" class="${p} h6">${d}</h5>
        <div slot="additional-content">${r}</div>
        <form target-filters is-mobile class="h-full">${s}</form>
      </modal-dialog>
    `}render(){var e,t,s,r,a,d,i,p;return l`<collection-results-section
      class="grid grid-cols-1 px-pagegridmargin pb-sm 2xl:container max-md:px-0 md:grid-cols-[minmax(0,295px)_minmax(0,1fr)] md:gap-x-lg md:gap-y-xs"
      data-pagination-results-per-page="${this.resultsPerPage}"
      target-content-results
      data-cnstrc-browse
      data-cnstrc-filter-name="group_id"
      data-cnstrc-filter-value="${this.collectionHandle}"
      data-cnstrc-num-results="${((e=this.collectionsData)==null?void 0:e.totalResults)??0}"
      data-loaded="${!!this.collectionsData.cards}"
      style="content-visibility: auto; contain-intrinsic-size: 0 2000px;"
    >
      ${this.getFilteredFacets(this.collectionsData.facets,"Desktop")}
      <aside class="md:block md:pb-6">
        <div class="max-md:hidden">
          <form target-filters>
            ${this.getFacetsHTML(this.collectionsData.facets,"Desktop")}
          </form>
        </div>

        ${this.getModalDialog("filter-drawer-dialog-content","left",this.getFacetsHTML(this.collectionsData.facets,"Mobile","filter-drawer-dialog-content"),this.getFilteredFacets(this.collectionsData.facets,"Mobile"),"drawer",this.textFilterResults,13,"!h4","!max-w-[22.5rem] !overflow-clip !text-t-foreground","!px-0 !py-md [&_.title-container]:!px-xs")}
        ${this.getModalDialog("sort-options-drawer-dialog-content","left",this.getSortHTML((t=this.collectionsData)==null?void 0:t.sortOptions,"Mobile"),l``,"drawer",this.textSort,13,"!h4","!max-w-[22.5rem]")}
      </aside>

      <div class="flex-grow" content-category-results="resources">
        <div>
          <div>
            <div
              id="content-grid-header-search"
              class="product-grid-header mb-sm flex flex-col md:mt-sm md:flex-row md:items-center md:justify-between md:gap-sm"
            >
              <div
                class="flex${window.brand=="NG"?" max-md:bg-t-background-secondary":""}"
              >
                <dialog-toggle
                  modal-id="filter-drawer-dialog-content"
                  class="w-full md:hidden"
                >
                  <button
                    class="flex h-button-height w-full items-center justify-center gap-2xs border border-t-border text-t-foreground"
                    aria-expanded="false"
                  >
                    <svg-icon
                      src="icon-filters"
                      class="block"
                      style="--icon-size: 25px;"
                    ></svg-icon>
                    <span class="text-utility-bold font-medium"
                      >${this.textFilter}</span
                    >
                  </button>
                </dialog-toggle>
                <dialog-toggle
                  modal-id="sort-options-drawer-dialog-content"
                  class="w-full md:hidden"
                >
                  <button
                    class="flex h-button-height w-full items-center justify-center gap-2xs border-y border-r border-t-border text-t-foreground"
                    aria-expanded="false"
                  >
                    <svg-icon
                      src="icon-sorting"
                      class="block"
                      style="--icon-size: 25px;"
                    ></svg-icon>
                    <span class="text-utility-bold font-medium"
                      >${this.textSort}</span
                    >
                  </button>
                </dialog-toggle>
                ${this.getSortHTML((s=this.collectionsData)==null?void 0:s.sortOptions,"Desktop")}
              </div>
              <span
                class="${window.brand=="NG"?"text-t-disabled":"text-t-foreground-secondary"} text-utility-regular max-md:mb-2xs max-md:mt-sm max-md:w-full max-md:px-pagegridmargin md:order-[-1]"
              >
                ${(r=this.collectionsData)!=null&&r.totalResults?(((a=this.collectionsData)==null?void 0:a.totalResults)==1?this.dataResultsGridWithCountOne:this.dataResultsGridWithCountOther).replace("{{ count }}",`${(i=(d=this.collectionsData)==null?void 0:d.totalResults)==null?void 0:i.toLocaleString("en-US")}`):y}
              </span>
            </div>
            <div>
              <div
                class="grid grid-cols-2 gap-x-xs gap-y-md max-md:px-pagegridmargin lg:grid-cols-4 lg:gap-y-7"
              >
                ${w(((p=this.collectionsData)==null?void 0:p.cards)??[],o=>o.handle,o=>{var u,c;return l`
                    <dynamic-product-card
                      handle="${o.handle}"
                      class="group/dynamic-product-card"
                      query-params="${this.collectionHandle.includes("free")&&this.collectionHandle.includes("samples")?"free-sample=true":""}"
                      template="${this.enableBundle?"product-card--bundle-cta":"product-card"}"
                    >
                      <div
                        data-slot="product-card-skeleton"
                        class="relative flex w-full flex-col group-has-[a]/dynamic-product-card:hidden"
                      >
                        <div
                          data-slot="product-card-skeleton-image"
                          class="${window.brand=="NG"?"rounded-sm":""} block aspect-square animate-pulseskeleton overflow-clip bg-t-border"
                        ></div>
                        <div class="flex flex-col gap-2xs pt-2.5">
                          <div
                            data-slot="product-card-skeleton-title"
                            class="${window.brand=="NG"?"rounded-sm":""} ${window.brand=="TFC"||window.brand=="WSP"?"pb-px":""} text-heading-6 box-content h-[1lh] max-w-[90%] animate-pulseskeleton bg-t-border font-medium leading-[1.2]"
                          ></div>
                          <div
                            data-slot="product-card-skeleton-reviews"
                            class="${window.brand=="NG"?"rounded-sm":""} mt-2xs h-2.5 max-w-[3.75rem] animate-pulseskeleton bg-t-border"
                          ></div>
                          <div
                            data-slot="product-card-skeleton-price"
                            class="${window.brand=="NG"?"rounded-sm":""} text-utility-regular mt-2xs h-[1lh] max-w-[7.75rem] animate-pulseskeleton bg-t-border"
                          ></div>
                          ${(u=window.cartDerivedDiscountBadgeSettings)!=null&&u.showCartDerivedDiscountBadge&&((c=window.cartDerivedDiscountBadgeSettings)!=null&&c.showCartDerivedDiscountBadgeOnProductCard)?l`<div
                                data-slot="product-card-skeleton-discount-badge"
                                class="${window.brand=="NG"?"rounded-full":""} caption mt-2xs flex max-w-[6rem] items-center justify-center gap-1 whitespace-nowrap bg-t-border p-2xs leading-none opacity-0"
                              >
                                <span class="block h-[1em]"></span>
                              </div>`:y}
                        </div>
                      </div>
                    </dynamic-product-card>
                  `})}
              </div>
            </div>
            ${this.getPaginateHTML(this.collectionsData.paginationIds,this.currentPage)}
          </div>
        </div>
      </div>
    </collection-results-section>`}};m([b({type:String,attribute:"data-content"})],h.prototype,"textContent",2);m([b({type:String,attribute:"data-sort"})],h.prototype,"textSort",2);m([b({type:String,attribute:"data-filter"})],h.prototype,"textFilter",2);m([b({type:String,attribute:"data-filter-counter"})],h.prototype,"textFilterCounter",2);m([b({type:String,attribute:"data-filters-counter"})],h.prototype,"textFiltersCounter",2);m([b({type:String,attribute:"data-see-result"})],h.prototype,"textDataSeeResult",2);m([b({type:String,attribute:"data-see-results"})],h.prototype,"textDataSeeResults",2);m([b({type:String,attribute:"data-from"})],h.prototype,"textFrom",2);m([b({type:String,attribute:"data-to"})],h.prototype,"textTo",2);m([b({type:String,attribute:"data-hide-count"})],h.prototype,"textHideCount",2);m([b({type:String,attribute:"data-view-all-count"})],h.prototype,"textViewAllCount",2);m([b({type:String,attribute:"data-apply"})],h.prototype,"textApply",2);m([b({type:String,attribute:"data-no-options-match-search"})],h.prototype,"textNoOptionsMatchSearch",2);m([b({type:String,attribute:"data-clear-all"})],h.prototype,"textClearAll",2);m([b({type:String,attribute:"data-results-grid-with-count-one"})],h.prototype,"dataResultsGridWithCountOne",2);m([b({type:String,attribute:"data-results-grid-with-count-other"})],h.prototype,"dataResultsGridWithCountOther",2);m([b({type:Number,attribute:"data-products-per-page"})],h.prototype,"resultsPerPage",2);m([b({type:String,attribute:"data-handle"})],h.prototype,"collectionHandle",2);m([b({type:Object})],h.prototype,"collectionsData",2);m([b({type:Number})],h.prototype,"facetsCheckboxVisibleLimit",2);m([b({type:Number})],h.prototype,"currentPage",2);m([b({type:Boolean,attribute:"enable-bundle"})],h.prototype,"enableBundle",2);m([b({type:String})],h.prototype,"textFilterResults",2);h=m([E("collection-results")],h);
